"use strict";
// This file was automatically generated by the Evolution Generator.
// The Evolution Generator is used to automate the creation of consistent, reliable code.
// Any changes made to this file will be overwritten.
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.tripsIntroOutro = exports.tripsIntro_save = exports.personDeparturePlaceOther = exports.personDeparturePlaceIsHome = exports.visitedPlacesIntro = exports.personDidTripsConfirm = exports.personDidTrips = exports.personWhoWillAnswerForThisPerson = exports.personNewPerson = exports.buttonSwitchPerson = exports.activePersonTitle = void 0;
const escape_1 = __importDefault(require("lodash/escape"));
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const defaultConditional_1 = require("evolution-common/lib/services/widgets/conditionals/defaultConditional");
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const odSurveyHelpers = __importStar(require("evolution-common/lib/services/odSurvey/helpers"));
const choices = __importStar(require("../../common/choices"));
const customConditionals = __importStar(require("../../common/customConditionals"));
const customWidgets = __importStar(require("./customWidgets"));
exports.activePersonTitle = customWidgets.activePersonTitle;
exports.buttonSwitchPerson = customWidgets.buttonSwitchPerson;
exports.personNewPerson = customWidgets.personNewPerson;
exports.personWhoWillAnswerForThisPerson = customWidgets.personWhoWillAnswerForThisPerson;
exports.personDidTrips = customWidgets.personDidTrips;
exports.personDidTripsConfirm = customWidgets.personDidTripsConfirm;
exports.visitedPlacesIntro = customWidgets.visitedPlacesIntro;
exports.personDeparturePlaceIsHome = customWidgets.personDeparturePlaceIsHome;
exports.personDeparturePlaceOther = Object.assign(Object.assign({}, defaultInputBase.inputRadioBase), { path: 'household.persons.{_activePersonId}.journeys.{_activeJourneyId}.departurePlaceOther', twoColumns: false, containsHtml: true, label: (t, interview, path) => {
        const activePerson = odSurveyHelpers.getPerson({ interview, path });
        const nickname = (0, escape_1.default)((activePerson === null || activePerson === void 0 ? void 0 : activePerson.nickname) || t('survey:noNickname'));
        const countPersons = odSurveyHelpers.countPersons({ interview });
        return t('tripsIntro:household.persons.{_activePersonId}.journeys.{_activeJourneyId}.departurePlaceOther', {
            nickname,
            count: countPersons
        });
    }, choices: choices.departurePlaceOtherChoices, conditional: customConditionals.departurePlaceOtherCustomConditional, validations: validations.requiredValidation });
exports.tripsIntro_save = Object.assign(Object.assign({}, defaultInputBase.buttonNextBase), { path: 'tripsIntro.save', label: (t) => t('tripsIntro:tripsIntro.save') });
exports.tripsIntroOutro = Object.assign(Object.assign({}, defaultInputBase.infoTextBase), { path: 'tripsIntroOutro', containsHtml: true, text: (t) => t('tripsIntro:tripsIntroOutro'), conditional: defaultConditional_1.defaultConditional });
